import React from 'react';
import { Loader2 } from 'lucide-react';
import { DbSchemaColumn } from '../../../types/import'; // Adjust path as needed

interface TableSelectorProps {
  tableNames: string[];
  selectedTable: string;
  handleTableChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  isLoadingSchema: boolean;
  schemaError: string | null;
  selectedTableColumns: DbSchemaColumn[];
}

export const TableSelector: React.FC<TableSelectorProps> = ({
  tableNames,
  selectedTable,
  handleTableChange,
  isLoadingSchema,
  schemaError,
  selectedTableColumns // Received but not directly used here, maybe later for info?
}) => {
  if (isLoadingSchema) {
    return (
      <div className="flex items-center space-x-2 text-gray-500">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span>Carregando schema do banco de dados...</span>
      </div>
    );
  }

  if (schemaError) {
    return (
      <div className="text-red-600 bg-red-100 border border-red-400 p-3 rounded">
        Erro ao carregar o schema: {schemaError}
      </div>
    );
  }

  return (
    <div className="mb-6 p-4 border rounded-md shadow-sm bg-white">
      <h2 className="text-lg font-semibold mb-3 text-gray-700">1. Selecionar Tabela de Destino</h2>
      <div className="flex flex-col space-y-2">
        <label htmlFor="tableSelect" className="text-sm font-medium text-gray-600">
          Tabela:
        </label>
        <select
          id="tableSelect"
          value={selectedTable}
          onChange={handleTableChange}
          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
          disabled={tableNames.length === 0}
        >
          <option value="" disabled>
            -- Selecione uma tabela --
          </option>
          {tableNames.map((tableName) => (
            <option key={tableName} value={tableName}>
              {tableName}
            </option>
          ))}
        </select>
        {tableNames.length === 0 && !isLoadingSchema && (
            <p className="text-sm text-yellow-600">Nenhuma tabela encontrada no schema.</p>
        )}
      </div>
    </div>
  );
}; 